import { render, staticRenderFns } from "./StatusModal.vue?vue&type=template&id=0b89db9b&"
import script from "./StatusModal.vue?vue&type=script&lang=js&"
export * from "./StatusModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports